Drupal.behaviors.search = {
  attach: function () {
    const searchPlaceholder = document.querySelector("#search-placeholder");
    const headerSearchOpen = document.querySelector("#header-search-open");
    const searchInput = headerSearchOpen.children[0][0];

    searchPlaceholder.addEventListener("click", function () {
      // Add aria-expanded="true" to the button
      searchPlaceholder.setAttribute("aria-expanded", "true");
      document.removeEventListener("click", checkIfClickInside);
      searchPlaceholder.style.display = "none";
      headerSearchOpen.style.display = "flex";
      searchInput.focus();
    });

    function checkIfClickInside(e) {
      const isClickInside = headerSearchOpen.contains(e.target);

      if (!isClickInside) {
        // if clicked outside of element
        searchPlaceholder.style.display = "flex";
        headerSearchOpen.style.display = "none";
      }
    }

    // listen for when searchInput loses focus
    searchInput.addEventListener("focusout", () => {
      document.addEventListener("click", checkIfClickInside);
      searchPlaceholder.setAttribute("aria-expanded", "false");
    });
  },
};
